<template>
    <div class="login-wrapper">
        <div class="login-container">
            <h1>{{ $t('Create account') }}</h1>
            <form @submit.prevent="submitInfo" @keydown="form.onKeydown($event)">
                <input type="text" id="name" autocomplete="false" :placeholder="$t('EnterName')" v-model="form.name"
                    required maxlength="255" minlength="3" />
                <input v-if="this.$store.state.auth != 0 && this.$store.state.auth != 4" type="email"
                    autocomplete="false" v-model="form.email" placeholder="example@gmail.com" required />
                <div v-else>
                    <input id="phone" class="input-field" type="text" name="phone" autocomplete=""
                        v-model="form.phone_basic" required :minlength=$store.state.country_length
                        :maxlength=$store.state.country_length style="text-align: center;"/>

                    <span class="flag">
                        {{ $store.state.country_code }}
                    </span>
                </div>
                <input type="password" autocomplete="new-password" v-model="form.password"
                    :placeholder="$t('EnterPass') +'*'" required minlength="8" />

                      <input
                id="passwordconfirm"
                class="input-field"
                type="password"
                autocomplete="new-password"
                name="name"
                :placeholder="$t('EnterPass')+'*'"
                required
                v-model="confirmPassword"
                minlength="8"
              />

                <button type="submit" class="signin" style="margin-top: 25px;" :disabled="form.busy">
                     {{ $t("CreateAccount") }} 
                      <i class="fa fa-spinner fa-spin " v-if="loading_register"></i>
                    </button>
                    <p style="color:red" v-if="errorMessage">{{ errorMessage }}</p>
            </form>




          
        </div>
    </div>
</template>
<script>

import Form from "vform";
import { AlertErrors, AlertSuccess } from "vform/src/components/bootstrap5";

export default {
    components: {
        AlertErrors,
        AlertSuccess,
    },
    props: {
        phone: String,
        email: String,
    },
    data: function () {
        return {
            loading_register:false,
            isValid: true,
            DBitems: null,
            confirmPassword: null,
            errorMessage: "",
            partphone: null,
            form: new Form({
                name: null,
                /*email: null,*/
                password: null,
                phone: null,
                phone_basic: null,
                email: null,
                fsm_token: this.$store.state.fsm_token,
            }),
        };
    },
    created() {
        if (this.phone != null) {
            this.form.phone = this.phone;
            this.partphone = true;
            this.isValid = true;
        } else if (this.email != null) {
            this.form.email = this.email;
        }
        //console.log("hiiiiiiiiii" +this.form.phone    +   "   "  + this.form.email)
    },
    methods: {
        async submitInfo() {
            this.loading_register=true;
            if (this.isValid) {
                if (this.confirmPassword == this.form.password) {
                    console.log(this.form.phone)
                    if (this.form.phone == null) {
                        this.form.phone = this.$store.state.country_code + this.form.phone_basic
                    }
                    console.log(this.form.phone)
                    const response = await this.form
                        .post(
                            this.$store.state.base_api_url +
                            this.$store.storeName +
                            "/register",

                            {
                                form: this.form,
                                headers: {
                                    "Accept-Language": this.$i18n.locale,
                                },
                            }
                        )
                        .then((response) => {
                                        this.loading_register=false;

                            if (response.data.code == "1") {
                                //this.DBitems = response.data.data.token; //22|JaYzuFIY4eyIXjIh7haHEGxGS8xowdbnkElztmHh//44444444
                                //this.$localStorage.set("userToken", response.data.data.token);
                                //this.$localStorage.start();
                                this.$localStorage.set(
                                    this.$store.storeName,
                                    response.data.data.token
                                );
                                //this.$localStorage.set("userToken", response.data.data.token);
                                console.log(
                                    this.$localStorage.get(this.$store.storeName) +
                                    " id : " +
                                    //this.$localStorage.id() +
                                    this.$store.storeName
                                );

                                console.log(
                                    "user token : " +
                                    this.$localStorage.get(this.$store.storeName)
                                );
                                /* this.$router.push({
                                   name: "home1",
                                   params: { storeName: this.$store.storeName },
                                 });
                                 window.location.reload();*/
                                window.location.href = '/';
                            } else if (response.data.code == "-1") {
                                this.errorMessage = response.data.message;
                                setTimeout(() => {
                                    this.errorMessage = "";
                                }, 3000);
                            }
                            if (response.data.error) {
                                this.errorMessage = "response.data.error";
                                setTimeout(() => {
                                    this.errorMessage = "";
                                }, 3000);
                            }
                        });
                } else {
                    if (this.$i18n.locale == "en") {
                        this.errorMessage = "the password not matching";
                        setTimeout(() => {
                            this.errorMessage = "";
                        }, 3000);
                    } else {
                        this.errorMessage = "كلمتا السر غير متطابقتين";
                        setTimeout(() => {
                            this.errorMessage = "";
                        }, 3000);
                    }
                }
            } else {
                if (this.$i18n.locale == "en") {
                    this.errorMessage = "your number isn't valid";
                    setTimeout(() => {
                        this.errorMessage = "";
                    }, 3000);
                } else {
                    this.errorMessage = "هذا الرقم غير صالح";
                    setTimeout(() => {
                        this.errorMessage = "";
                    }, 3000);
                }
            }
        },
    },
};
</script>